import React from 'react';
import {
  Box,
  Typography,
  Button,
  Stack,
} from '@mui/material';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import AddCardOutlinedIcon from '@mui/icons-material/AddCardOutlined';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

function ResponsiveActions() {
  const navigate = useNavigate();

  const actions = [
    {
      label: 'Send',
      icon: <SendOutlinedIcon sx={{ fontSize: 26 }} />,
      onClick: () => navigate('/local-transfer'),
      gradient: 'linear-gradient(135deg, #0ea5e9, #38bdf8)',
      shadow: '#38bdf8',
    },
    {
      label: 'Transactions',
      onClick: () => navigate('/deposit'),
      icon: <ReceiptLongOutlinedIcon sx={{ fontSize: 26 }} />,
      outlined: true,
      borderColor: '#7B2FF2',
      shadow: '#9B51E0',
    },
    {
      label: 'Fund Wallet',
      icon: <AddCardOutlinedIcon sx={{ fontSize: 26 }} />,
      onClick: () => navigate('/deposits'),
      gradient: 'linear-gradient(135deg, #0ea5e9, #2F80ED)',
      shadow: '#2F80ED',
    },
  ];

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '1200px',
        px: { xs: 3, sm: 4 },
        overflowX: 'auto',
      }}
    >
      

      {/* Quick Actions */}
      <Stack
        direction="row"
        spacing={3}
        flexWrap="nowrap"
        sx={{
          overflowX: 'auto',
          pb: 1,
          '&::-webkit-scrollbar': { display: 'none' },
        }}
      >
        {actions.map((action, index) => (
          <motion.div whileHover={{ scale: 1.1 }} key={index}>
            <Stack alignItems="center" spacing={1}>
              <Button
                onClick={action.onClick}
                sx={{
                  minWidth: 54,
                  height: 54,
                  width: 54,
                  borderRadius: '50%',
                  color: action.outlined ? action.borderColor : '#fff',
                  background: action.outlined ? 'transparent' : action.gradient,
                  border: action.outlined ? `2px solid ${action.borderColor}` : 'none',
                  boxShadow: `0 0 6px 0 ${(action.shadow || action.borderColor) + '44'}`,
                  transition: '0.2s',
                  '&:hover': {
                    background: action.outlined
                      ? action.borderColor
                      : action.gradient.replace('60%', '40%'),
                    color: '#fff',
                    boxShadow: `0 0 12px 0 ${action.shadow || action.borderColor}`,
                  },
                }}
              >
                {action.icon}
              </Button>
              <Typography
                variant="caption"
                fontWeight={500}
                sx={{ color: 'text.primary', fontSize: '0.75rem' }}
              >
                {action.label}
              </Typography>
            </Stack>
          </motion.div>
        ))}
      </Stack>
    </Box>
  );
}

export default ResponsiveActions;